<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="促销活动" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="feedback-form mb-5">
      <div style="margin-top: 1rem;">
        <mt-field label="促销折扣" v-model="discountInfo.point" type="number"></mt-field>
        <mt-cell title="是否开启折扣">
            <mt-switch v-model="discountInfo.discount"></mt-switch>
        </mt-cell>
        <mt-button size="large" type="primary" class="mt-10" @click="savePromotion">保存</mt-button>
      </div>
    </div>
  </div>
</template>

<script>
import { discountSave, queryDiscount } from '../../../api/sellerGoods'
import { Toast } from 'mint-ui'
export default {
  name: 'SellerPromotion',
  data () {
    return {
      controller: 'Sellerindex',
      discountInfo: {
        point: 9,
        discount: false
      }
    }
  },
  created () {
    // 查询折扣信息
    queryDiscount(this.controller)
      .then((res) => {
        if (res.code === 10000) {
          this.discountInfo.point = res.result.point
          this.discountInfo.discount = Boolean(res.result.discount)
        }
      })
      .catch((error) => {
        Toast(error.message)
      })
  },
  methods: {
    // 保存折扣信息
    savePromotion () {
      let saveParam = {
        point: this.discountInfo.point,
        discount: this.discountInfo.discount ? 1 : 0
      }
      discountSave(this.controller, saveParam)
        .then((res) => {
          Toast(res.message)
          this.$router.go(-1)
        })
        .catch((error) => {
          Toast(error.message)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  background: #fff;
}
</style>
